<template>
	<v-navigation-drawer
		v-model="show"
		:width="clientWidth"
		fixed
		right
		temporary
		class="related-content-list-picker"
		@input="handleDrawerToggled">

		<template v-if="loading">
			<v-layout fill-height align-center justify-center ma-0>
				<v-progress-circular :indeterminate="loading"></v-progress-circular>
			</v-layout>
		</template>
		<template v-else>
			<v-card class="preview-panel">
				<v-toolbar color="grey lighten-2" flat v-if="title">
				    <v-toolbar-title class="grey--text text--darken-4" v-html="title"></v-toolbar-title>
				    <v-spacer></v-spacer>
				    <v-btn icon light>
				        <v-icon color="grey darken-2" @click.stop="handleClose">close</v-icon>
				    </v-btn>
				</v-toolbar>

				<v-card-text>
					<content-list 
						:specific-content-type="specificContentType"
						:selected-contents="contents"
						:include-unpublish-content="includeUnpublishContent"
						:action="handlePickerAction">
					</content-list>
				</v-card-text>

				<v-card-actions v-if="actionButtons" class="px-4">
					<template v-for="(action, index) in buttonsOnLeft">
						<v-btn v-bind="action.options" :text="action.options.text" @click="handleActionClick(action)" class="mt-12">{{ action.text }}</v-btn>
					</template>
					<v-spacer></v-spacer>
					<template v-for="(action, index) in buttonsOnRight">
						<v-btn v-bind="action.options" :text="action.options.text" @click="handleActionClick(action)" class="mt-12">{{ action.text }}</v-btn>
					</template>					
				</v-card-actions>
			</v-card>
		</template>
	</v-navigation-drawer>	
</template>

<script>
	import * as config from '@/config'

	import ContentList from '@/components/ContentList'

	export default {
		components: {
			ContentList
		},
		props: {
			title: {
				type: String,
				default: ''
			},
			contents: {
				type: [Array],
				default: null
			},
			actionButtons: {
				type: Array,
				default: null
			},
			specificContentType: {
				type: String,
				default: ''
			},
			includeUnpublishContent: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				show: false,
				loading: false,
				content: null
			}
		},
		computed: {
			clientWidth () 
			{
				return (window.innerWidth > 640) ? 640 : window.innerWidth
			},
			contentTitle () 
			{
				if (!this.content) {
					return ''
				} else if (this.contentKeys.contentType.toLowerCase() == 'comment') {
					return (typeof this.content.rootContent.content !== 'undefined') ? this.content.rootContent.content.title : ''
				} else {
					return (typeof this.content.title !== 'undefined') ? this.content.title : ''
				}
			},
			contentCreator () 
			{
				if (!this.content) {
					return ''
				} else if (this.contentKeys.contentType.toLowerCase() == 'comment') {
					return (typeof this.content.rootContent.content !== 'undefined') ? this.content.rootContent.content.user.username : ''
				} else {
					return (typeof this.content.user.username !== 'undefined') ? this.content.user.username : ''
				}
			},
			contentPublishedOn () 
			{
				if (!this.content) {
					return null
				} else if (this.contentKeys.contentType.toLowerCase() == 'comment') {
					return (typeof this.content.rootContent.content !== 'undefined') ? this.content.rootContent.content.publishedOn : null
				} else {
					return (typeof this.content.publishedOn !== 'undefined') ? this.content.publishedOn : null
				}
			},
			contentUrl () 
			{
				if (!this.contentKeys) {
					return ''
				} else if (this.contentKeys.contentType.toLowerCase() == 'comment') {
					return `https://www.jeban.com/${this.content.rootContent.contentType.toLowerCase()}/${this.content.rootContent.contentId}/comment/${this.content.id}`
				} else if (this.contentKeys.contentType.toLowerCase() == 'check') {
					return `https://www.jeban.com/beautycheck/${this.contentKeys.contentId}`
				} else {
					return `https://www.jeban.com/${this.contentKeys.contentType.toLowerCase()}/${this.contentKeys.contentId}`
				}
			},
			contentApi ()
			{
				if (!this.contentKeys) {
					return ''
				} else if (this.contentKeys.contentType.toLowerCase() == 'check') {
					return `${config.BASE_URL}/beautycheck/${this.contentKeys.contentId}`
				} else {
					return `${config.BASE_URL}/${this.contentKeys.contentType.toLowerCase()}/${this.contentKeys.contentId}`
				}				
			},
			buttonsOnLeft () 
			{
				return this.actionButtons.filter(a => ((typeof a.align === 'undefined') || (a.align != 'right')))
			},
			buttonsOnRight ()
			{
				return this.actionButtons.filter(a => ((typeof a.align !== 'undefined') && (a.align == 'right')))
			}
		},
		methods: {
			handleOpenContent ()
			{
				window.open(this.contentUrl, '_blank')
			},
			handleClose () 
			{
				this.$emit('close')
			},
			handleActionClick (action)
			{
				this.$emit(action.eventName, this.contentKeys)
			},
			handleDrawerToggled (value)
			{
				if (!value) this.$emit('close')
			},
			handlePickerAction (value) 
			{
				this.$emit('action', value)
			}
		},
		mounted () {
	        window.addEventListener('keyup', e => {
	            // If  ESC key was pressed...
	            if (e.keyCode === 27) {
	                // try close your dialog
	                this.handleClose()
	            }
	        })
		},
		watch: {
			contents (value) 
			{
				this.show = (value) ? true : false
				if (value) {
					this.loading = true
					axios.get(this.contentApi)
						.then(response => {
							this.content = response.data.data
							this.loading = false
						})
						.catch(error => {
							console.log(error)
							this.loading = false
						})
				}
			}
		}
	}
</script>

<style lang="scss">
	.v-toolbar__title {
		cursor: pointer;
		user-select: none;
	}
	.preview-panel {
		min-height: 100vh;
		display: flex;
		flex-flow: column;

		.content-body {
			flex: 1;

			.v-image__image--contain {
				background-position: left center !important;
			}
			.v-avatar {
				.v-image__image--contain {
					background-position: center center !important;
				}
			}

			.before-after-block {
				border-top: 1px dashed #ccc;
				border-bottom: 1px dashed #ccc;
			}
		}

		.root-content {
			opacity: .5;
		}
	}

	.border-bottom-dashed {
		border-bottom: 1px dashed #ccc;
	}
</style>